import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import Assets from './Assets/Assets'
import DashboardContent from './DashboardContent/DashboardContent'
import Header from './Header/Header'
import { useDefaultComponentTools } from '../../hooks/useDefaultComponentTools'

const Dashboard = ({depositHeight}) => {
	const { mdUp, lgUp, mdDown } = useDefaultComponentTools()
	const [headerHeight, setHeaderHeight] = useState(56)

	return (
		<Box sx={{mb: mdUp ? 0 : `${depositHeight + 'px'}`}}>
			<Header setHeaderHeight={setHeaderHeight}/>
			<Box sx={{ columnGap: lgUp ? '16px' : '8px', display: 'grid',
				gridTemplateColumns:  mdDown ? '1fr' : (lgUp ? '458px 1fr' : '400px 1fr'),
				height: mdUp ? `calc(100vh - ${(headerHeight + depositHeight) + 'px'})` : 'auto',
				mt: mdUp ? 0 : headerHeight + 'px',
				p: lgUp ? '16px' : '8px', rowGap: '8px'
			}}
			>
				<Box sx={{height: mdUp ? '100%' : 'auto',	overflow: 'hidden'}}>
					<Assets headerHeight={headerHeight + depositHeight}/>
				</Box>
				<Box  sx={{height: mdUp ? '100%' : 'auto',	overflow: 'hidden'}}>
					<DashboardContent />
				</Box>
			</Box>
		</Box>
	)
}

Dashboard.propTypes = {
	depositHeight: PropTypes.number
}
export default Dashboard
